import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BASE_PATH } from ".././../constants/Global";
import "react-datepicker/dist/react-datepicker.css";
import Navigationtitle from "../include/Navigationtitle";
import DataService from ".././../services/tutorial.service";
import Demo from "../crop/Demo";
import { playerlistData } from "../../actions/index";
import { useMediaQuery } from "react-responsive";
import $ from "jquery";
import { playerdefaultLogo } from "../../constants/Images";
import moment from "moment";
import { getDatabase, ref, remove, onValue, set, update } from "firebase/database";
import ownerimg from '../../assets/images/owner.svg'
import ImageCropper from "../cropper/ImageCropper";
import { bat } from "../../constants/Images";
import { ball } from "../../constants/Images";
import { wkeeper } from "../../constants/Images";
function Addplayers(match) {
    const dispatch = useDispatch();
    const getpageData = useSelector((state) => state.setplayerlistData);
    const getTeamList = useSelector((state) => state.setteamlistData);
    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
    } = useForm();
    const [isDisabled, setDisabled] = useState(false);
    const loginuser = useSelector((state) => state.setUserlog);

    const [batting, setBatting] = useState("");
    const [bowling, setBowling] = useState("");
    const [otherBatting, setOtherBatting] = useState(false);
    const [otherBowling, setOtherBowling] = useState(false);
    const [playingStyle, setPlayingStyle] = useState("batsman");
    const [croppedImage, setCroppedImage] = useState("");
    const [dataTeam, setTeamData] = useState([]);
    const [othersp3, setOthersp3] = useState(false);
    const [sp3, setsp3] = useState("");

    const [cid, setCid] = useState(loginuser["cid"]);
    const [sp1opt, setsp1opt] = useState(['All Rounder', 'Batting All Rounder', 'Bowling All Rounder', 'All Rounder Wicketkeeper', 'Batsman', 'Bowler', 'Wicket Keeper', 'Batter', 'Other']);
    const [sp2opt, setsp2opt] = useState(['Right Hand', 'Left Hand', 'Right Hand Batsman', 'Left Hand Batsman', 'Right Hand Opener', 'Left Hand Opener', 'Right Hand Middle Order', 'Left Hand Middle Order']);
    const [sp3opt, setsp3opt] = useState(['Right Arm Fast', 'Right Arm Medium', 'Left Arm Fast', 'Left Arm Medium', 'Off-Break', 'Leg-Break', 'Left Arm Orthodox', 'Left Arm Chinaman']);

    const [isOwner, setIsOwner] = useState("");
    const [defaultIsOwner, setDefaultIsOwner] = useState(false);
    const [isNonPlayer, setIsNonPlayer] = useState(false);
    const [catData, setcatData] = useState([]);

    const [catid, setcatid] = useState("");
    const [tagid, settagid] = useState("");
    const [isbat, setisbat] = useState(false);
    const [isbol, setisbol] = useState(false);
    const [iswkeep, setiswkeep] = useState(false);

    const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
    const isPortrait = useMediaQuery({ query: "(orientation: portrait)" });
    const updtoken = useSelector((state) => state.updtoken);

    const history = useHistory({ forceRefresh: true });
    var savenew = 0;
    let logo_pic = "";
    const aid = localStorage.getItem("auction_id");
    const fetchcatData = async () => {
        //  console.log("andr aaaya")
        //  console.log(aid)
        // setActive(true);

        var hdr = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                "authorization": JSON.stringify([{ 'cid': cid, 'token': loginuser["token"] }])
            }
        }

        await DataService.listCategory({ 'aid': aid }, hdr)
            .then(res => {

                let response = res.data;
                //  console.log(response);

                if (response.success == true) {

                    let responsedata = response.data;
                    //  console.log(" cat list kya h");
                    //  console.log(responsedata);
                    setcatData(responsedata.list);
                }
                // setActive(false);

            }).catch(() => {
                //  console.log('Not valid')
                // setActive(false);
            })
    };
    const fetchTeamData = async () => {
        var hdr = {
            params: {
                frm: 1,
            },
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                authorization: JSON.stringify([
                    { cid: cid, aid: aid, token: loginuser["token"] },
                ]),
            },
        };

        await DataService.listTeam({}, hdr)
            .then((res) => {
                let response = res.data;

                if (response.success == true) {
                    let responsedata = response.data;

                    setTeamData(responsedata.list);
                    // setteampath(responsedata.path);
                    // dispatch(teamlistData({ responsedata }));
                }
            })
            .catch(() => {
                //  console.log("Not valid");
            });
    };
    const onSubmit = (values) => {
        setDisabled(true);
        const id = toast.loading("Please wait...");
        let toastContainerId = toast.update(id, {
            render: "please wait...",
            theme: "dark",
        });
        if (document.getElementById("logo_pic") != null) {
            logo_pic = document.getElementById("logo_pic").value;
        }
        var hdr = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
            },
        };

        var icon = ''
        if (isbat == true) {
            if (icon == '') {
                icon += 'bat.png'
            }
            else {
                icon += ',bat.png'
            }

        }
        if (isbol == true) {
            if (icon == '') {
                icon += "ball.png"
            }
            else {
                icon += ",ball.png"
            }

        }
        if (iswkeep == true) {
            if (icon == '') {
                icon += "gloves.png"
            }
            else {
                icon += ",gloves.png"
            }

        }

        values["icons"] = icon;
        values["logo_pic"] = croppedImage;
        values["isowner"] = isOwner;
        values["isnonplay"] = isNonPlayer;
        values["spcf1"] = batting;
        values["spcf2"] = bowling;
        values["spcf3"] = sp3;
        values["chkowner"] = defaultIsOwner == true ? 1 : 0;
        if (values["ownertag"] == undefined) {
            values["ownertag"] = ""
        }
        //  console.log('pl submited')
        //  console.log(values)
        DataService.addPlayer(values, hdr)
            .then((res) => {
                let response = res.data;
                //  console.log('new entry')
                //  console.log(response)
                toast.dismiss(toastContainerId);
                //  console.log("values")
                //  console.log(values["catid"])
                if (response.success == true) {

                    const db = getDatabase();
                    //  console.log("values")
                    //  console.log(response.data)
                    set(ref(db, 'map/info/' + aid), {
                        "type": "4", "upd": "1", 'id': "", "detail": {
                            "age": values.age,
                            "base": values.base,
                            "catid": values.catid ? values.catid : '',
                            "fname": values.fname,
                            "icons": values.icons,
                            "detail": values.detail,
                            "isnonplay": values.isnonplay,
                            "isowner": values.isowner,
                            "jrnm": values.jrno,
                            "img": values.logo_pic,
                            "mob": values.mob,
                            "ownertag": values.ownertag,
                            "pcode": response.data.new.pcode,
                            "pid": response.data.pid,
                            "pname": values.pname,
                            "spcf1": values.spcf1,
                            "spcf2": values.spcf2,
                            "spcf3": values.spcf3,
                            "trouser": values.trouser,
                            "tshirt": values.tshirt,
                        }, "tkn": updtoken
                    });
                    //  console.log(response.data);
                    let submitdata = [response.data.new];

                    let responsedata = {};
                    if (getpageData == 0) {
                        responsedata = {
                            responsedata: {
                                path: response.data.path,
                                aid: aid,
                                list: [...submitdata],
                            },
                        };
                    } else {
                        responsedata = {
                            responsedata: {
                                path: response.data.path,
                                aid: aid,
                                list: [...submitdata, ...getpageData.responsedata.list],
                            },
                        };
                    }
                    dispatch(playerlistData(responsedata));

                    toast.success(response.msg, {
                        theme: "dark",
                        position: "bottom-center",
                    });
                    if (savenew == 0) {
                        history.push(BASE_PATH + "auction-players");
                    } else {
                        setValue("pcode", "");
                        setValue("mob", "");
                        setValue("pname", "");
                        setValue("fname", "");
                        setValue("dob", "");
                        setValue("tshirt", "");
                        setValue("trouser", "");
                        setValue("detail", "");

                        setValue("wkeep", 0);
                        $(".crop-default img").attr("src", playerdefaultLogo);
                    }
                } else {
                    toast.error(response.msg, { theme: "colored" });
                }

                setDisabled(false);
            })
            .catch(() => {
                //  console.log("Not valid");
                toast.dismiss(toastContainerId);
                toast.error("Not valid Server Error", { theme: "colored" });
                setDisabled(false);
            });
    };

    useEffect(() => {
        fetchTeamData()
        $(".crop-default img").attr("src", playerdefaultLogo);
        $(".crop-default").click(function () {
            $("#crop-pic").click();
        });
        fetchcatData()
    }, [Demo]);


    var batstyle = {
        backgroundColor: 'white'
    }
    var bolstyle = {
        // backgroundColor: 'white'
    }
    var wkeepstyle = {
        backgroundColor: 'white'
    }
    if (isbat == true) {
        batstyle = {
            backgroundColor: 'black',
            color: 'white',
            border: '5px solid white'
        }
    }
    if (isbol == true) {
        bolstyle = {
            backgroundColor: 'black',
            color: 'white',
            border: '5px solid white'
        }
    }
    if (iswkeep == true) {
        wkeepstyle = {
            backgroundColor: 'black',
            color: 'white',
            border: '5px solid white'
        }
    }
    return (
        <>
            <div>
                <Navigationtitle data={match} />

                <div className="formbg">
                    <div className="formmain">
                        <form onSubmit={handleSubmit(onSubmit)}
                            action=""
                            autoComplete="off"
                            encType="multipart/form-data">
                            <div className="formflex">
                                <div className="formhalf">
                                    <div className="formphoto flex">
                                        <div className="addplphotolabel">

                                        </div>
                                        <div className="formimage">
                                            <ImageCropper
                                                croppedImage={croppedImage}
                                                setCroppedImage={setCroppedImage}
                                                defaultimage={playerdefaultLogo}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="formhalf">
                                    <div className="formfield">
                                        <label htmlFor="">Form Number</label>
                                        <input
                                            className="form-control"
                                            // //placeholder="Enter Form Number"
                                            type="number"
                                            //placeholder="Enter Form Number"
                                            id="pcode"
                                            {...register("pcode", {})}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="formflex">
                                <div className="formhalf">
                                    <div className="formfield">
                                        <label htmlFor="">Name*</label>
                                        <input
                                            className="form-control"
                                            //placeholder="Enter Name"
                                            type="text"
                                            id="pname"
                                            {...register("pname", {
                                                required: true,
                                                required: "required field.",
                                            })}
                                        />
                                        {errors.pname && (
                                            <p className="text-error">
                                                {errors.pname.message}
                                            </p>
                                        )}
                                    </div>
                                </div>
                                <div className="formhalf">
                                    <div className="formfield">
                                        <label htmlFor="">Father's Name</label>
                                        <input
                                            className="form-control"
                                            //placeholder="Enter Father Name"
                                            id="fname"
                                            type="text"
                                            {...register("fname", {})}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="formflex">
                                <div className="formhalf">
                                    <div className="formfield">
                                        <label htmlFor="">Age</label>
                                        <input
                                            className="form-control"
                                            type="number"
                                            //placeholder="Age"
                                            id="age"
                                            {...register("age", {})}
                                        />
                                    </div>
                                </div>
                                <div className="formhalf">
                                    <div className="formfield">
                                        <label htmlFor="">Mobile Number</label>
                                        <input
                                            className="form-control"
                                            //placeholder="Mobile Number"
                                            type="number"
                                            id="mob"
                                            {...register("mob", {})}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="formflex">
                                {catData != '' &&
                                    <div className="formhalf">
                                        <div className="formfield">
                                            <label htmlFor="">Select Category</label>
                                            <select className="form-control" name="category" id=""
                                                {...register("catid")}
                                                value={
                                                    catid
                                                }
                                                onChange={(e) => {
                                                    setcatid(e.target.value);
                                                }}>
                                                <option value="">Select category</option>
                                                {catData?.map(
                                                    (ct) => (
                                                        <option
                                                            value={ct.cid}
                                                            key={ct.cid}
                                                        >
                                                            {ct.cname}
                                                        </option>
                                                    )
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                }
                                <div style={{ gap: "2rem" }} className="formhalf flex ">


                                    <div className="formfield dif-field2">
                                        <div className="mystyletag"> <span htmlFor="">Style</span> </div>
                                        <div
                                            className="myplstyle"
                                        >

                                            <div className="" >
                                                <img onClick={() => setisbat(!isbat)} src={bat} alt="" style={batstyle} />
                                            </div>
                                            <div className="" >
                                                <img onClick={() => setisbol(!isbol)} src={ball} alt="" style={bolstyle} />
                                            </div>
                                            <div className="">
                                                <img onClick={() => setiswkeep(!iswkeep)} src={wkeeper} alt="" style={wkeepstyle} />
                                            </div>
                                        </div>


                                    </div>
                                    <div className="formfield dif-field">

                                        <div> <img src={ownerimg} alt="" />  {!defaultIsOwner && <span htmlFor="">Is team owner ?</span>}</div>
                                        <div>
                                            <input
                                                type="checkbox"
                                                id="isowner"
                                                style={{ marginRight: '2rem' }}
                                                // {...register("isowner", {})}
                                                onClick={(e) =>
                                                    setDefaultIsOwner(e.target.checked)
                                                }
                                            />


                                        </div>
                                        { defaultIsOwner && <><div> <span htmlFor="">Is Non Playing ?</span> </div>
                                        <div>
                                            <input
                                                type="checkbox"
                                                id="isowner"
                                                style={{ marginRight: '2rem' }}
                                                // {...register("isowner", {})}
                                                onClick={(e) =>
                                                    setIsNonPlayer(e.target.checked)
                                                  }
                                            />


                                        </div></>}
                                    </div>

                                </div>
                            </div>
                            {defaultIsOwner &&
                                <div className="formflex">
                                    <div className="formhalf">
                                        <div className="formfield">
                                            <label htmlFor="">Select Team</label>
                                            <select
                                                className="form-control"
                                                id="isowner"
                                                type="text"
                                                // {...register("isowner")}
                                                onChange={(e) => {
                                                    setIsOwner(e.target.value);
                                                }}
                                                value={isOwner}
                                                disabled={defaultIsOwner ? false : true}
                                            >
                                                <option disabled value="" selected>
                                                    Select Team
                                                </option>
                                                {dataTeam.map(
                                                    (team) => (
                                                        <option
                                                            value={team.tid}
                                                            key={team.tid}
                                                        >
                                                            {team.name}
                                                        </option>
                                                    )
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="formhalf">
                                        <div className="formfield">
                                            <label htmlFor="">Select Tag</label>
                                            <select
                                                className="form-control"
                                                type="text"
                                                {...register("ownertag")}
                                                value={
                                                    tagid
                                                }
                                                onChange={(e) => {
                                                    settagid(e.target.value);
                                                }}
                                                disabled={defaultIsOwner > 0 || defaultIsOwner ? false : true}
                                            >
                                                <option value='0' selected>
                                                    Select tag
                                                </option>
                                                <option value='1'>
                                                    Owner
                                                </option>
                                                <option value='2' >
                                                    Co-owner
                                                </option>
                                                <option value='3'>
                                                    Icon
                                                </option>


                                            </select>
                                        </div>
                                    </div>

                                </div>
                            }
                            <div className={`formflex ${!otherBatting && 'fl-left'}`}>
                                <div className={`formhalf ${!otherBatting && 'fl-left'}`}>
                                    <div className="formfield">
                                        <label htmlFor="">Specification 1</label>
                                        <select
                                            className="form-control"
                                            id="spcf1"
                                            type="text"
                                            {...register("spcf1", {
                                                required: false,
                                                // required: "required field.",
                                            })}
                                            onChange={(e) => {
                                                if (e.target.value === "Other") {
                                                    setOtherBatting(true);
                                                } else {
                                                    setOtherBatting(false);
                                                }
                                                setBatting(e.target.value);
                                            }}
                                        // value={batting}
                                        >
                                            <option value={""}>--Specification 1--</option>
                                            {/* <option value="Right Hand Batsman">
                                        Right Hand Batsman
                                      </option>
                                      <option value="Left Hand Batsman">
                                        Left Hand Batsman
                                      </option> */}
                                            {sp1opt.map((ele) => (
                                                <option value={ele}>
                                                    {ele}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.spcf1 && (
                                            <p className="text-error">
                                                {errors.spcf1.message}
                                            </p>
                                        )}

                                    </div>
                                </div>
                                {otherBatting &&
                                    <div className="formhalf">
                                        <div className="formfield">
                                            <label htmlFor="">Other</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                //placeholder="Other"
                                                onChange={(e) =>
                                                    setBatting(e.target.value)
                                                }
                                            />
                                        </div>
                                    </div>
                                }

                            </div>
                            <div className={`formflex ${!otherBowling && 'fl-left'}`}>
                                <div className={`formhalf ${!otherBowling && 'fl-left'}`}>
                                    <div className="formfield">
                                        <label htmlFor="">Specification 2</label>
                                        <select
                                            className="form-control"
                                            id="spcf2"
                                            type="text"
                                            {...register("spcf2", {
                                                required: false,
                                                // required: "required field.",
                                            })}
                                            onChange={(e) => {
                                                if (e.target.value === "Other") {
                                                    setOtherBowling(true);
                                                } else {
                                                    setOtherBowling(false);
                                                }
                                                setBowling(e.target.value);
                                            }}
                                        >
                                            <option value={""}>--Specification 2--</option>
                                            {(batting == 'Bowling All Rounder' || batting == 'Bowler') ? sp3opt.map((ele) => (
                                                <option value={ele}>
                                                    {ele}
                                                </option>
                                            )) : sp2opt.map((ele) => (
                                                <option value={ele}>
                                                    {ele}
                                                </option>
                                            ))}
                                            <option value='Other'>
                                                Other
                                            </option>
                                        </select>
                                        {errors.spcf1 && (
                                            <p className="text-error">
                                                {errors.spcf1.message}
                                            </p>
                                        )}
                                    </div>
                                </div>
                                {otherBowling &&
                                    <div className="formhalf">
                                        <div className="formfield">
                                            <label htmlFor="">Other</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                //placeholder="Other"
                                                onChange={(e) =>
                                                    setBowling(e.target.value)
                                                }
                                            />
                                        </div>
                                    </div>
                                }

                            </div>
                            <div className={`formflex ${!othersp3 && 'fl-left'}`}>
                                <div className={`formhalf ${!othersp3 && 'fl-left'}`}>
                                    <div className="formfield">
                                        <label htmlFor="">Specification 3</label>
                                        <select
                                            className="form-control"
                                            id="spcf3"
                                            type="text"
                                            {...register("spcf3", {
                                                required: false,
                                                // required: "required field.",
                                            })}
                                            onChange={(e) => {
                                                if (e.target.value === "Other") {
                                                    setOthersp3(true);
                                                } else {
                                                    setOthersp3(false);
                                                }
                                                setsp3(e.target.value);
                                            }}
                                        >
                                            <option value={""}>--Specification 3--</option>
                                            {(batting == 'Bowling All Rounder' || batting == 'Bowler') ? sp2opt.map((ele) => (
                                                <option value={ele}>
                                                    {ele}
                                                </option>
                                            )) : sp3opt.map((ele) => (
                                                <option value={ele}>
                                                    {ele}
                                                </option>
                                            ))}

                                            <option value='Other'>
                                                Other
                                            </option>
                                        </select>
                                        {errors.spcf2 && (
                                            <p className="text-error">
                                                {errors.spcf2.message}
                                            </p>
                                        )}
                                    </div>
                                </div>
                                {othersp3 &&
                                    <div className="formhalf">
                                        <div className="formfield">
                                            <label htmlFor="">Other</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                //placeholder="Other"
                                                onChange={(e) =>
                                                    setBowling(e.target.value)
                                                }
                                            />
                                        </div>
                                    </div>
                                }

                            </div>
                            <div className="formflex">
                                <div className="formhalf">
                                    <div className="formfield">
                                        <label htmlFor="">T-shirt size</label>
                                        <select
                                            className="form-control"
                                            type="text"
                                            id="tshirt"
                                            {...register("tshirt", {})}
                                        >
                                            <option value="">--select--</option>
                                            <option value="S">S</option>
                                            <option value="M">M</option>
                                            <option value="L">L</option>
                                            <option value="XL">XL</option>
                                            <option value="XXL">XXL</option>
                                            <option value="XXXL">XXXL</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="formhalf">
                                    <div className="formfield">
                                        <label htmlFor="">Trouser size</label>
                                        <select
                                            className="form-control"
                                            id="trouser"
                                            type="text"
                                            {...register("trouser", {})}
                                        >
                                            <option value="">--select--</option>
                                            <option value="S">S</option>
                                            <option value="M">M</option>
                                            <option value="L">L</option>
                                            <option value="XL">XL</option>
                                            <option value="XXL">XXL</option>
                                            <option value="XXXL">XXXL</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="formflex">
                                <div className="formhalf">
                                    <div className="formfield">
                                        <label htmlFor="">Jersey Name</label>
                                        <input
                                            className="form-control"
                                            type="text"
                                            //placeholder="Jersey Name"
                                            id="jrnm"
                                            {...register("jrnm", {})}
                                        />
                                    </div>
                                </div>
                                <div className="formhalf">
                                    <div className="formfield">
                                        <label htmlFor="">Jersey Number</label>
                                        <input
                                            className="form-control"
                                            //placeholder="Jersey Number"
                                            type="number"
                                            id="jrno"
                                            {...register("jrno", {})}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="formflex">
                                <div className="formfull">
                                    <div className="formfield">
                                        <label htmlFor="">Detail</label>
                                        <input
                                            className="form-control"
                                            //placeholder="Detail"
                                            type="text"
                                            id="detail"
                                            {...register("detail", {})}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="formflex">
                                <div className="formhalf">
                                    <div className="formfield">
                                        <label htmlFor="">Base</label>
                                        <input
                                            className="form-control"
                                            //placeholder="Base"
                                            type="text"
                                            id="base"
                                            {...register("base", {})}
                                        />
                                    </div>
                                </div>
                                <div className="formhalf">
                                    <div className="formfield">
                                        <p style={{ position: 'relative', top: '4rem' }}>(If different from Minimum Base or category Base value)</p>
                                    </div>
                                </div>
                            </div>
                            <div className="formflex formbtn fl-left">
                                <div className="formhalf fl-left">

                                    <button onClick={() => (savenew = 1)} type="submit">Save and Add new</button>
                                    <button onClick={() => (savenew = 0)} type="submit">Add Player</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Addplayers;
